module.exports = __webpack_public_path__ + "static/img/logo_xlh.9457e64e.png";